import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import "./style.css";
import { resolveMediaUrl } from "../../../firebase/helpers";
import Logo from "../../images/logo.png";

function Property() {
  const { projects } = useSelector((state) => state.projects);
  const { categories } = useSelector((state) => state.categories);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const [slice, setSlice] = useState(14);
  const [display, setDisplay] = useState("");

  const filteridData = projects.filter((item) =>
    filter ? item.categories_id === filter : true
  );

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 50,
      smooth: "easeInOutQuint",
    });
  };

  return (
    <main className="content-wrapper">
      <div className="container  pb-5 mb-2 mb-sm-3 mb-lg-4 mb-xl-5">
        <nav
          aria-label="breadcrumb"
          className="position-relative pt-3 my-3 my-md-4"
          style={{ zIndex: "1021" }}
        >
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={"/"}>الرئيسية</Link>
            </li>
            <li aria-current="page" className="breadcrumb-item active">
              المنتجات
            </li>
          </ol>
        </nav>

        <h1
          className="h3 text-center position-relative pb-sm-2 pb-md-3"
          style={{ zIndex: "1021" }}
        >
          المنتجات
        </h1>

        <div
          dir="rtl"
          className="sticky-top bg-body mb-3 mt-1 mb-sm-4"
          style={{ marginTop: "-4.5rem" }}
        >
          <div className="row align-items-center pt-5">
            <div className="col-12 col-sm-12 col-md-12 mt-2">
              <ul
                className="nav nav-underline flex-nowrap justify-content-start overflow-auto"
                id="viewShwitcher"
                style={{ whiteSpace: "nowrap" }}
              >
                <li className="nav-item d-inline-block mb-1" role="presentation">
                  <button
                    onClick={() => setFilter("")}
                    aria-selected={filter === ""}
                    className={`nav-link ${filter === "" ? "active" : ""}`}
                    role="tab"
                    type="button"
                  >
                    الكل
                  </button>
                </li>
                {categories.map((item) => (
                  <li
                    key={item.id}
                    className="nav-item d-inline-block mb-1"
                    role="presentation"
                  >
                    <button
                      onClick={() => setFilter(item.id)}
                      aria-selected={filter === item.id}
                      className={`nav-link ${filter === item.id ? "active" : ""}`}
                      role="tab"
                      type="button"
                    >
                      {item.categori_name_ar}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 gy-5" id="productGrid">
          {filteridData.slice(0, slice).map((item) => {
            const imageUrl = resolveMediaUrl(item?.images?.[0]?.product_photo, Logo);

            return (
              <div key={item.id} className="col">
                <div className="animate-underline mb-sm-2">
                  <Link
                    to={`/info_product/${item.id}`}
                    onClick={scrollToTop}
                    className="hover-effect-opacity ratio ratio-1x1 d-block mb-3"
                  >
                    <img
                      alt={item.product_title_ar}
                      className="hover-effect-target opacity-100"
                      src={imageUrl}
                    />
                    <img
                      alt={item.product_title_ar}
                      className="position-absolute top-0 start-0 hover-effect-target opacity-0 rounded-4"
                      src={imageUrl}
                    />
                  </Link>

                  <h3 className="mb-2">
                    <Link
                      to={`/info_product/${item.id}`}
                      onClick={scrollToTop}
                      className="d-block fs-sm fw-medium text-truncate"
                    >
                      <span className="animate-target">{item.product_title_ar}</span>
                    </Link>
                  </h3>
                  <div className="h6">{item.product_price} د.ع </div>
                  <div className="d-flex gap-2">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://api.whatsapp.com/send?phone=+9647748999948&text=مرحبًا%0Aأنا أود شراء المنتج ${item.product_title_ar}%0Aرمز المنتج: ${item.product_code}%0Aالسعر: ${item.product_price}%0Aيرجى تقديم المزيد من المعلومات حول المنتج وكيفية الشراء.%0Aشكرًا.`}
                      data-action="share/whatsapp/share"
                      type="button"
                      className="btn btn-dark w-100 rounded-pill px-3"
                    >
                      طلب سريع
                    </a>
                    <button
                      onClick={() => {
                        dispatch({
                          type: "add",
                          id: item.id,
                          colorId: 2,
                        });
                      }}
                      type="button"
                      className="btn btn-secondary rounded-pill animate-pulse"
                      aria-label="Add to cart"
                    >
                      <i className="ci-shopping-cart animate-target" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div
          className={`text-center pt-5 mt-md-2 mt-lg-3 mt-xl-4 mb-xxl-3 mx-auto ${display}`}
          style={{ maxWidth: "306px" }}
        >
          <p className="fs-sm">
            عرض {filteridData.length < 15 ? filteridData.length : slice} من {filteridData.length}
          </p>
          <div
            aria-label="Items shown"
            className="progress mb-3"
            role="progressbar"
            style={{ height: "4px" }}
          >
            <div className="progress-bar bg-dark rounded-pill" style={{ width: "100%" }} />
          </div>
          {slice < filteridData.length ? (
            <div className="nav justify-content-center">
              <button
                className="nav-link animate-underline fs-base pt-2 pb-0 px-0 border-0 bg-transparent"
                onClick={() => {
                  setSlice(filteridData.length);
                  setDisplay("d-none");
                }}
              >
                <span className="animate-target my-1 me-2">أظهر المزيد</span>
                <i className="ci-chevron-down fs-lg" />
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </main>
  );
}

export default Property;